import axios from "axios";

export const http = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("cwsb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const aud = (n) => `$${Math.round(n ?? 0).toLocaleString("en-AU")}`;
